import React, { useEffect, useState } from 'react'
import Loader from '../../components/Loader'
import { toast } from 'react-toastify'
import { api } from '../../app/Api/ApiSlice'
import StoreFeedCard from '../../components/StoreFeedCard'
import "./storesStyles.css"
import InfiniteScroll from 'react-infinite-scroll-component'
import { useParams } from 'react-router-dom'

const CategoryStores = () => {
  const [stores, setStores] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)

  useEffect(() => {
    fetchShops()
  }, [page])

  const { category } = useParams()

  const fetchShops = async () => {
    try {
      setIsLoading(true)
      const response = await api.get(`/stores/category/${category}`, { params: { page } })

      const newStores = response.data || []

      if (newStores.length === 0) {
        setHasMore(false)
      } else {
        setStores((prev) => [...prev, ...newStores])
      }

    } catch (error) {
      setHasMore(false)
      toast.error(error.response?.data?.message || "Failed to load stores")
    } finally {
      setIsLoading(false)
    }
  }

  const loadMore = () => {
    setPage((prev) => prev + 1)
  }

  return (
    <div className='store-feeds page-body'>
      <div className="stores-page-content">
        <div className="stores-page-header">
          <h2 className='stores-page-title'>{category} Businesses</h2>
        </div>
        {isLoading && <Loader />}
        <div className="shop-feeds-list">
          <InfiniteScroll
            dataLength={stores.length}
            next={loadMore}
            hasMore={hasMore}
            loader={<Loader />}
            endMessage={<p>No more Businesses available.</p>}
          >
            <div className="stores-grid">
              {
                stores.map((str, index) => (
                  <StoreFeedCard key={index} str={str} />
                ))
              }
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  )
}

export default CategoryStores
